module.exports = __webpack_public_path__ + "img/advertise_logo.9a844cc7.png";